class MultipleImageQuestionStrategy {
    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;
        this.mediaContainer = null;
        this.questionContainer = null;
        // this.timeout = null;
        this.images =[];

        $(".showImageBtn").click(function(event){
            event.stopPropagation();

            $('#myModalMM').show();

            // var modalImg = document.getElementById("img01");
            // modalImg.src = $(this).attr('data-img');
            $('#img01').css({
                'background-image': 'url('+$(this).attr('data-img')+')',
                'background-size': 'contain',
                'background-repeat': 'no-repeat',
                'background-color': 'transparent',
                'background-position': 'center center'
            });

            var span = document.getElementsByClassName("close")[0];
            span.onclick = function() {$('#myModalMM').hide();};

            return false;
        });
    };

    draw() {
        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.questionContainer.removeClass('h-100-p');
        var fixedItemsHeight = $(".play-top").height()+$(".play-info").height()+$(".play-bottom").height()+this.questionContainer.find(".question").outerHeight()-2;

        if (window.innerHeight > fixedItemsHeight + 400) {  // Si las imagenes son mas pequeñas que la ventana, que ocupen toda la ventana
            this.questionContainer.css('height', 'calc(125% - ' + fixedItemsHeight + 'px)');
        }

        this.questionContainer.css('min-height', '');
        this.questionContainer[0].style.setProperty( 'padding', '0', 'important' );
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');

        $(window).resize(() => {
            this.playScreenController.imageContainerHeight();

            fixedItemsHeight = $(".play-top").height()+$(".play-info").height()+$(".play-bottom").height()+this.questionContainer.find(".question").outerHeight()-2;
            if (window.innerHeight > fixedItemsHeight + 400) {
                this.questionContainer.css('height', 'calc(125% - ' + fixedItemsHeight + 'px)');
            }
            this.resizeImages();
        });

        // Crear componentes
        this.images = [this.playScreenController.currentQuestion.correct_answer,this.playScreenController.currentQuestion.answer_2];
        if(this.playScreenController.currentQuestion.answer_3){
            this.images.push(this.playScreenController.currentQuestion.answer_3);
        }
        if(this.playScreenController.currentQuestion.answer_4){
            this.images.push(this.playScreenController.currentQuestion.answer_4);
        }

        let that = this;
        switch (this.images.length) {
            case 2:
                $(".multiple-images-col").each(function (index) {
                    if(index == 0){
                        $(this).css('border-top', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '2.5px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else {
                        $(this).css('border-top', '2.5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                    }
                });
                break;
            case 3:
                $(".multiple-images-col").each(function (index) {
                    if(index == 0){
                        $(this).css('border-top', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-right', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else if(index == 1) {
                        $(this).css('border-top', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-left', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else {
                        $(this).css('border-top', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                    }
                });
                break;
            case 4:
                $(".multiple-images-col").each(function (index) {
                    if(index == 0){
                        $(this).css('border-top', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-right', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else if(index == 1) {
                        $(this).css('border-top', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-left', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else if(index == 2) {
                        $(this).css('border-top', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-right', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                    } else {
                        $(this).css('border-top', '3px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-left', '2px solid #' + that.playScreenController.currentQuestion.category.color);
                        $(this).css('border-bottom', '5px solid #' + that.playScreenController.currentQuestion.category.color);
                    }
                });
                break;
        }

        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_ANSWER"]).appendTo(this.mediaContainer);
        $('body').addClass('stop-scrolling');
        this.preload()
    };

    preload() {
        $(this.images).each(function(){
            $('<img/>')[0].src = this;
        });

        this.resizeImages();

        $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        $(".question-color-wrapper").show();

        this._preloadTimeout = setTimeout(this.startTime.bind(this), 1000);
    };

    startTime() {
        this.hideImage();
        this.resizeImages();

        $(".question-color-wrapper").hide();

        this.playScreenController.startTimer(this.result);
    };

    hideImage() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.mediaContainer.slideUp();
        $('body').removeClass('stop-scrolling');
    };

    cancel() {
        clearTimeout(this._preloadTimeout);
    }

    resizeImages(){
        $(".img-v-container:not(.hot-spot)").each(function () {
            let currentImg = $(this).find(".img-responsive-v");
            currentImg.css('width', 0);
            currentImg.css('height', 0);

            let maxWidth = $(this).width();
            let maxHeight = $(this).height();
            let ratio = 0;
            let imgSrc = currentImg.attr('src');

            if(typeof(imgSrc) !== 'undefined') {
                let width = currentImg[0].naturalWidth;
                let height = currentImg[0].naturalHeight;

                function adjustSize() {
                    ratio = maxWidth / width;

                    currentImg.css('width', maxWidth - 20 + 'px');
                    currentImg.css('height', height * ratio - 20 + 'px');
                    width = maxWidth;
                    height = height * ratio;

                    if (height > maxHeight) {
                        ratio = maxHeight / height;
                        currentImg.css('height', maxHeight - 20 + 'px');
                        currentImg.css('width', width * ratio - 20 + 'px');
                    }
                }

                if(width !== 0 || height !== 0){
                    adjustSize();
                } else {
                    let tempImg = new Image();

                    tempImg.onload = function(){
                        width = currentImg[0].naturalWidth;
                        height = currentImg[0].naturalHeight;

                        adjustSize();
                    };

                    tempImg.src = imgSrc;
                }
            }
        });
    }
}